import { render, staticRenderFns } from "./TypeSpotDetail.vue?vue&type=template&id=7b31a07e&"
import script from "./TypeSpotDetail.vue?vue&type=script&lang=js&"
export * from "./TypeSpotDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports